import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IActivePassengerForAddons } from "../../../Orchestrator/Types/Interface/ActionParams/GetAddonsParams";

export class ActivePassengerForAddons extends BaseAction<
  IDefaultActionResult,
  IActivePassengerForAddons
> {
  override async run(): Promise<IDefaultActionResult | null> {
    const actionResult: IDefaultActionResult = {
      data: null,
      message: "",
      status: "fail",
    };
    try {
      let { addonsPassengerList, activePassenger, legId } = this.params!;            
      addonsPassengerList = [...addonsPassengerList].map(({ ...legPass }) => {
        if (legId === legPass.legId) {
          legPass.addonsPassenger = [...(legPass?.addonsPassenger || [])].map(
            ({ ...p }) => {
              if (p.passengerId === activePassenger.passengerId)
                p.isActive = true;
              else p.isActive = false;
              return p;
            }
          );
        }
        return legPass;
      });
      updateRecoilState("addonsPassengerListAtom", addonsPassengerList);

      actionResult.status = "success";
    } catch (error: any) {
      console.log("error", error);
      actionResult.message = error.message;
    } finally {
      return actionResult;
    }
  }
}

export const activePassengerForAddons = new ActivePassengerForAddons();
